import React, { FunctionComponent } from "react";
import { Button, CardActionArea, Stack, useTheme } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import styles from "./styles.module.scss";
import { FilterElement, FilterType } from "../../../models/FilterElement";
import { StarsRating } from "../../attributes/impacts/StarsRating";
import { GoldmineRatingCard } from "../../attributes/GoldmineRatingCard";
import { AttributeUtilities } from "../../../models/AttributeUtilities";

export const GenericFilterComponent: FunctionComponent<IGenericFilterComponentProps> = ({
  filterElement,
  isNegated,
  onClick,
  onNegatedChange
}) => {
  const theme = useTheme();
  return (
    <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={"center"}>
      {filterElement.canBeNegated && onNegatedChange && (
        <Button
          onClick={() => onNegatedChange(!isNegated)}
          sx={{
            fontSize: "15px",
            fontWeight: "normal",
            padding: 0,
            borderWidth: 1,
            borderColor: theme.palette.colors?.border,
            borderStyle: "solid",
            borderRadius: "12px",
            color: isNegated ? theme.palette.colors.remove : undefined,
            height: "30px !important"
          }}
        >
          {isNegated ? strings.filter_is_not : strings.filter_is}
        </Button>
      )}
      <CardActionArea
        className={styles.filterComponentTitle}
        sx={{
          borderRadius: "12px !important",
          borderWidth: 1,
          borderColor: theme.palette.colors?.border,
          borderStyle: "solid",
          minHeight: "30px !important"
        }}
        onClick={onClick}
      >
        {filterElement.filterType == FilterType.IMPACT && filterElement.textValue ? (
          <div style={{ paddingLeft: 8 }}>
            <StarsRating value={+filterElement.elementId} />
          </div>
        ) : (filterElement.filterType == FilterType.SLEEVE_GRADE ||
            filterElement.filterType == FilterType.MEDIA_GRADE) &&
          filterElement.textValue ? (
          <Stack style={{ paddingLeft: 8, alignItems: "center" }} direction={"row"} spacing={1}>
            <p>{AttributeUtilities.getGoldmineGradePoints(+filterElement.elementId + 1)}</p>
            <GoldmineRatingCard
              points={+filterElement.elementId + 1}
              goldmineGrading={filterElement.textValue}
            />
          </Stack>
        ) : (
          <p
            className={styles.genericFilterTitle}
            style={{
              color: filterElement.textValue
                ? theme.palette.primary.main
                : theme.palette.colors?.disabled
            }}
          >
            {filterElement.textValue ?? strings.no_value}
          </p>
        )}
      </CardActionArea>
    </Stack>
  );
};

export interface IGenericFilterComponentProps {
  filterElement: FilterElement;
  isNegated: boolean;
  onClick: (event: React.MouseEvent) => void;
  onNegatedChange?: (newValue: boolean) => void;
}
